export class ComparisonNormalizer {
  /**
   * Normalize any value to a trimmed, lower‑cased string.
   * null/undefined -> ""
   */
  static string(value: unknown): string {
    if (value == null) {
      return "";
    }

    if (Array.isArray(value)) {
      return value.join(",").trim().toLowerCase();
    }

    switch (typeof value) {
      case "string":
        return value.trim().toLowerCase();

      case "number":
      case "bigint":
      case "boolean":
        return value.toString().trim().toLowerCase();

      default:
        return "";
    }
  }

  /**
   * Normalize any value to a number.
   * - numeric strings -> parsed number
   * - invalid/NaN -> 0
   */
  static number(value: unknown): number {
    const num = typeof value === "number" ? value : Number(value);
    return Number.isNaN(num) ? 0 : num;
  }

  /**
   * Normalize any value to a boolean.
   * - boolean -> itself
   * - string "true"/"1" (case‑insensitive) -> true
   * - string "false"/"0" (case‑insensitive) -> false
   * - everything else -> Boolean(value)
   */
  static boolean(value: unknown): boolean {
    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "string") {
      const lowerValue = value.trim().toLowerCase();
      if (lowerValue === "true" || lowerValue === "1") {
        return true;
      }
      if (lowerValue === "false" || lowerValue === "0") {
        return false;
      }
    }

    return Boolean(value);
  }

  static object(value: unknown): Record<string, unknown> {
    if (value === null || typeof value !== "object" || Array.isArray(value)) {
      return {};
    }
    return value as Record<string, unknown>;
  }
}
